function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import getDisplayName from '../../../getDisplayName';
var DEFAULT_TEMP_FILES = [];
var TempFilesContext = createContext({
  files: DEFAULT_TEMP_FILES,
  setTempFiles: function setTempFiles() {}
});
var FormFilesContext = createContext({
  files: [],
  fileUploadUrl: ''
});
export default FormFilesContext;
var isPopulatedArray = function isPopulatedArray(arr) {
  return arr && Array.isArray(arr) && arr.length !== 0;
};
var toLocationIndex = function toLocationIndex(files) {
  return files.reduce(function (acc, file) {
    acc[file.location] = file;
    return acc;
  }, {});
};
export function withSingleFileChangeHandler(WrappedComponent) {
  var Wrapped = function Wrapped(props) {
    var onChange = props.onChange,
      rest = _objectWithoutProperties(props, ["onChange"]);
    var handleChange = useCallback(function (files) {
      var _files = isPopulatedArray(files) ? files[0].location : undefined;
      onChange(_files);
    }, [onChange]);
    return /*#__PURE__*/React.createElement(WrappedComponent, Object.assign({
      onChange: handleChange
    }, rest));
  };
  Wrapped.displayName = "withSingleFileChangeHandler(".concat(getDisplayName(WrappedComponent), ")");
  return Wrapped;
}
export function withMultiFileChangeHandler(WrappedComponent) {
  var Wrapped = function Wrapped(props) {
    var onChange = props.onChange,
      rest = _objectWithoutProperties(props, ["onChange"]);
    var handleChange = useCallback(function (files) {
      var _files = isPopulatedArray(files) ? files.map(function (file) {
        return file.location;
      }) : undefined;
      onChange(_files);
    }, [onChange]);
    return /*#__PURE__*/React.createElement(WrappedComponent, Object.assign({
      onChange: handleChange
    }, rest));
  };
  Wrapped.displayName = "withMultiFileChangeHandler(".concat(getDisplayName(WrappedComponent), ")");
  return Wrapped;
}
export function withWidgetFiles(WrappedComponent) {
  var Wrapped = function Wrapped(props) {
    var onChange = props.onChange,
      value = props.value,
      rest = _objectWithoutProperties(props, ["onChange", "value"]);
    var formFilesContext = useContext(FormFilesContext);
    var tempFilesContext = useContext(TempFilesContext);
    var widgetFiles = useMemo(function () {
      var _widgetFiles = [];
      var _allFiles = [].concat(_toConsumableArray(formFilesContext.files), _toConsumableArray(tempFilesContext.files));
      if (value) {
        if (Array.isArray(value)) {
          var index = toLocationIndex(_allFiles);
          value.forEach(function (val) {
            var file = index[val];
            if (index[val]) {
              _widgetFiles.push(file);
            }
          });
        } else {
          for (var _index = 0; _index < _allFiles.length; _index++) {
            var file = _allFiles[_index];
            if (file.location === value) {
              _widgetFiles.push(file);
              break;
            }
          }
        }
      }
      return _widgetFiles;
    }, [formFilesContext.files, tempFilesContext.files, value]);
    var handleChange = useCallback(function (files) {
      if (files) {
        var _files = Array.isArray(files) ? _toConsumableArray(files) : [files];
        if (_files.length > 0) {
          var _formFilesByLocation = toLocationIndex(formFilesContext.files);
          var _tempFilesByLocation = toLocationIndex(tempFilesContext.files);
          var _newTempFiles = tempFilesContext.files.slice();
          _files.forEach(function (file) {
            if (!_formFilesByLocation[file.location] && !_tempFilesByLocation[file.location]) {
              _newTempFiles.push(file);
            }
          });
          tempFilesContext.setTempFiles(_newTempFiles);
        }
      }
      onChange(files);
    }, [onChange, formFilesContext.files, tempFilesContext.files, tempFilesContext.setTempFiles]);
    return /*#__PURE__*/React.createElement(WrappedComponent, Object.assign({
      files: widgetFiles,
      onChange: handleChange,
      value: value,
      url: formFilesContext.fileUploadUrl
    }, rest));
  };
  Wrapped.displayName = "wrapFileWidgetWithTempFiles(".concat(getDisplayName(WrappedComponent), ")");
  return Wrapped;
}
export function withFormFiles(WrappedComponent) {
  var Wrapped = function Wrapped(props) {
    // @ts-ignore
    var onFileMetadataChange = props.onFileMetadataChange;
    var _useContext = useContext(FormFilesContext),
      files = _useContext.files;
    var _useState = useState(DEFAULT_TEMP_FILES),
      _useState2 = _slicedToArray(_useState, 2),
      tempFiles = _useState2[0],
      setTempFiles = _useState2[1];
    useEffect(function () {
      if (onFileMetadataChange) {
        onFileMetadataChange([].concat(_toConsumableArray(files), _toConsumableArray(tempFiles)));
      }
    }, [files, onFileMetadataChange, tempFiles]);
    return /*#__PURE__*/React.createElement(TempFilesContext.Provider, {
      value: {
        files: tempFiles,
        setTempFiles: setTempFiles
      }
    }, /*#__PURE__*/React.createElement(WrappedComponent, props));
  };
  Wrapped.displayName = "WithFormFiles(".concat(getDisplayName(WrappedComponent), ")");
  return Wrapped;
}